import { Form, Input } from 'antd'
import React, { useRef, useState } from 'react'
import { IoIosSend } from 'react-icons/io';
import dayjs from 'dayjs';
import './style.css'
import { getSocketInstance } from '../../../../../config/hooks/utility/socket';
import TextArea from 'antd/es/input/TextArea';

const ChatInput = ({ chatData, newUserMessage }) => {
    // const { channelId } = data ?? {} //channel/room id or undefined
    const { channelId, senderId, receiverId } = chatData

    const [inputValue, setInputValue] = useState('')

    let socket = getSocketInstance()
    const formRef = useRef(null);
    const [form] = Form.useForm();

    const handleMessageInput = (e) => {
        setInputValue(e.target.value)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission or default Enter behavior
          setInputValue((prev) => prev + "\n"); // Add a new line to the message
        }
    };

    const handleSubmit = () => {
        if (inputValue.trim()) {
            formRef.current.submit();

            sendMessage();
        }
    };

    const sendMessage = () => {
        if (inputValue.trim()) {
            socket.emit("message:send", { channelId, senderId, receiverId, message: inputValue });

            const createdAt = dayjs().toISOString();            
            newUserMessage({createdAt, message:inputValue, senderId})
            setInputValue('')
        }
    };
    

    return (
        <div className='flex flex-col justify-center py-2'>
            <div className='flex items-center'>
                <div className='flex flex-col w-full justify-center input'>
                    <Form
                        form={form}
                        ref={formRef}
                        name="myForm"
                        // onFinish={handleSubmit}
                        layout="vertical"
                    >
                        <Form.Item
                            label=""
                            name="message"
                            className='mb-0'
                        >
                            {/* tmp input field to clear input */}
                            <input type='submit' value={inputValue} onChange={handleMessageInput} className='tmp-input' />
                            <div className='relative'>
                                <TextArea
                                    className='w-100 h-[40px] message-box rounded-[7px] bg-slate-100 p-2'
                                    placeholder="Type your message"
                                    type='text'
                                    maxLength={500}
                                    value={inputValue}
                                    onChange={handleMessageInput}
                                    onKeyDown={handleKeyDown}
                                    rows={1}
                                />
                                <div className='flex justify-end absolute top-1/2 right-2 transform -translate-y-1/2 text-[16px] text-[#1890ff] cursor-pointer'>
                                    <div className='lg:w-full md:w-full sm:w-full w-1/2 mr-2'>
                                        <div className={`w-[30px] h-[30px] p-[1px] sm:p-1 flex justify-center items-center rounded-full
                                            ${!inputValue ? 'pointer-events-none bg-gray-200' : 'cursor-pointer bg-black'}    
                                        `}>
                                            <IoIosSend
                                                className={`text-white text-2xl p-1`}
                                                onClick={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default ChatInput